import React from 'react'
import { SchoolCardSkeleton } from '@systemeio/light-lecture-viewer'

export const SchoolCardsSkeleton = () => {
  return (
    <>
      <SchoolCardSkeleton className="hidden sm:block" />
      <SchoolCardSkeleton className="hidden sm:block" />
      <SchoolCardSkeleton className="hidden sm:block" />
      <SchoolCardSkeleton />
      <SchoolCardSkeleton />
      <SchoolCardSkeleton />
      <SchoolCardSkeleton className="hidden xl:block" />
      <SchoolCardSkeleton className="hidden xl:block" />
    </>
  )
}
